var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";

var ClassroomIcon = function ClassroomIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "shale" : _ref$color,
      onClick = _ref.onClick,
      cursor = _ref.cursor,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      props = _objectWithoutProperties(_ref, _excluded);

  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.466 11.24l-.138-.438c-.138-.44-.662-.672-1.17-.517l-.822.25.002-2.82c0-1.498-1.234-2.713-2.757-2.713L10.768 5c-1.524-.001-2.76 1.212-2.76 2.71l-.002 2.771-.663-.202c-.508-.155-1.032.076-1.17.516l-.139.438c-.139.44.16.922.668 1.077l1.262.385-.145 2.725a.849.849 0 00-.03.17l-.217 2.953a.839.839 0 00.786.891l.854.06a.845.845 0 00.908-.772l.13-1.795 3.738.002.129 1.796c.033.46.439.805.906.773l.854-.06a.839.839 0 00.787-.89l-.135-1.88a361.93 361.93 0 01-.152-3.924c.027-.006.055-.012.082-.02l1.338-.407c.508-.155.808-.636.67-1.076zm1.16-3.718c2.315.24 2.816 1.847 2.972 4.607-.04.03 1.966 1.707 1.246 1.876-.72.17-1.45-.15-1.45-.15s.567 6.03-1.303 2.578c-.025.002-1.564.875-3.39.062-.047-.002-.528-.213-.528-.213s-.124-2.11-.08-2.907c.003-.04 1.122-.202 1.475-.669.353-.466.343-1.11.172-1.784-.172-.674-.587-1.244-.996-1.36-.41-.115-.727.028-.727.028L17 9.11s.312-1.828 2.627-1.587zm-15.253 0c-2.314.24-2.815 1.847-2.971 4.607.04.03-1.966 1.707-1.246 1.876.72.17 1.45-.15 1.45-.15s-.567 6.03 1.303 2.578c.025.002 1.564.875 3.39.062.046-.002.528-.213.528-.213s.124-2.11.08-2.907c-.003-.04-1.122-.202-1.475-.669-.353-.466-.343-1.11-.172-1.784.172-.674.587-1.244.996-1.36.41-.115.728.028.728.028L7 9.11S6.688 7.28 4.373 7.522z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 5,
        width: 24,
        height: 15,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.466 11.24l-.138-.438c-.138-.44-.662-.672-1.17-.517l-.822.25.002-2.82c0-1.498-1.234-2.713-2.757-2.713L10.768 5c-1.524-.001-2.76 1.212-2.76 2.71l-.002 2.771-.663-.202c-.508-.155-1.032.076-1.17.516l-.139.438c-.139.44.16.922.668 1.077l1.262.385-.145 2.725a.849.849 0 00-.03.17l-.217 2.953a.839.839 0 00.786.891l.854.06a.845.845 0 00.908-.772l.13-1.795 3.738.002.129 1.796c.033.46.439.805.906.773l.854-.06a.839.839 0 00.787-.89l-.135-1.88a361.93 361.93 0 01-.152-3.924c.027-.006.055-.012.082-.02l1.338-.407c.508-.155.808-.636.67-1.076zm1.16-3.718c2.315.24 2.816 1.847 2.972 4.607-.04.03 1.966 1.707 1.246 1.876-.72.17-1.45-.15-1.45-.15s.567 6.03-1.303 2.578c-.025.002-1.564.875-3.39.062-.047-.002-.528-.213-.528-.213s-.124-2.11-.08-2.907c.003-.04 1.122-.202 1.475-.669.353-.466.343-1.11.172-1.784-.172-.674-.587-1.244-.996-1.36-.41-.115-.727.028-.727.028L17 9.11s.312-1.828 2.627-1.587zm-15.253 0c-2.314.24-2.815 1.847-2.971 4.607.04.03-1.966 1.707-1.246 1.876.72.17 1.45-.15 1.45-.15s-.567 6.03 1.303 2.578c.025.002 1.564.875 3.39.062.046-.002.528-.213.528-.213s.124-2.11.08-2.907c-.003-.04-1.122-.202-1.475-.669-.353-.466-.343-1.11-.172-1.784.172-.674.587-1.244.996-1.36.41-.115.728.028.728.028L7 9.11S6.688 7.28 4.373 7.522z"
        })
      })]
    }))
  });
};

var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
ClassroomIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  ClassroomIcon = nessiePropCheckerWrapper(ClassroomIcon);
}

export default ClassroomIcon;
//# sourceMappingURL=ClassroomIcon.js.map